import Vue from 'vue';
import Support from './support.vue';
import Mixins from '../../mixins/mixin';

Vue.mixin(Mixins);

// Only run this script when the element exists in the DOM
if(document.getElementById('js-support-form')){
    new Vue({
        el: '#js-support-form',
        components: {
            'support': Support
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/vue/components/support/support-form.js